export const SERVER_URL = 'http://localhost:8080/'
export const SERVER_URL_GOOGLE = SERVER_URL + "oauth2/authorization/google"
export const LOGIN_URL = "/login"
export const SIGNUP_URL = '/signup'
export const MAIN_PAGE = "/main-page"
export const RESTAURANT = "/restaurant"
export const PROFILE_URL = "/profile"